import { render, staticRenderFns } from "./roleAuth.vue?vue&type=template&id=43e059f5&scoped=true"
import script from "./roleAuth.vue?vue&type=script&lang=js"
export * from "./roleAuth.vue?vue&type=script&lang=js"
import style0 from "./roleAuth.vue?vue&type=style&index=0&id=43e059f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e059f5",
  null
  
)

export default component.exports